import styled from 'styled-components';
import COLORS from '../../colors';
import { SummaryContainer } from '../containers';

interface DetailProps {
  title: string;
  content: string;
}

interface DetailSummaryProps {
  heading: string;
  details: DetailProps[];
}

const Title = styled.b`
  position: relative;
  line-height: 16px;
`;

const Content = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.WHITE};
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Row = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 29px;
`;

const Details = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  font-size: 12px;
  color: ${COLORS.NEUTRAL_500};
  margin-top: 32px;
`;

const renderOverviewDetails = (items: DetailProps[]) => {
  const detailItems = [];

  for (var i = 0; i < items.length; i += 3) {
    detailItems.push(
      <Row>
        {items.slice(i, i + 3).map((item: DetailProps, i: number) => (
          <ContentContainer key={i}>
            <Title>{item.title}</Title>
            <Content>{item.content}</Content>
          </ContentContainer>
        ))}
      </Row>
    );
  }

  return detailItems;
};

const DetailSummary = ({ heading, details }: DetailSummaryProps) => {
  return (
    <SummaryContainer title={heading}>
      <Details>
        {details && details.length > 0 && renderOverviewDetails(details)}
      </Details>
    </SummaryContainer>
  );
};

export default DetailSummary;
